import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UAParser } from 'ua-parser-js';

import { AuthDeviceService } from '../../core/auth/services/auth-device.service';
import { APP_VERSION } from '../../core/tokens';

function getOSData(): { name?: string; version?: string } {
  try {
    const ua = new UAParser(navigator.userAgent);
    const os = ua.getOS();
    return { name: os.name, version: os.version };
  } catch (error) {
    console.error(error);
  }

  const userAgent = window.navigator.userAgent;
  if (userAgent.indexOf('Win') != -1) return { name: 'Windows' };
  if (userAgent.indexOf('Mac') != -1) return { name: 'macOS' };
  if (userAgent.indexOf('Linux') != -1) return { name: 'Linux' };

  return {};
}

export function apiDeviceInfoInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authDeviceService = inject(AuthDeviceService);
  const appVersion = inject(APP_VERSION);
  const os = getOSData();

  const headers = req.headers
    .append('x-device-id', authDeviceService.getOrGenerate())
    .append('x-app-version', appVersion)
    .append('x-device-os-name', os.name || 'Unknown')
    .append('x-device-os-version', os.version || '0');

  return next(
    req.clone({
      headers,
    }),
  );
}
